import api from '@/services/api'
import type { WithdrawalCreateRequest, WithdrawalResponse } from './types'

export const WithdrawalsV2Service = {
  createWithdrawal(data: WithdrawalCreateRequest) {
    return api.post<WithdrawalResponse>('/v2/withdrawals', data)
  },
  getWithdrawals() {
    return api.get<WithdrawalResponse[]>('/v2/withdrawals')
  },
  cancelWithdrawal(requestId: number) {
    return api.put<WithdrawalResponse>(`/v2/withdrawals/${requestId}/cancel`)
  },
}
